import React, { Fragment } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'

function WithNavigate({ children }) {
  let navigate = useNavigate()
  let params = useParams()
  const location = useLocation()
  return (
    <Fragment>
      {React.cloneElement(children, { navigate, params, location })}
    </Fragment>
  )
}
export default WithNavigate
